import VideoListStore from "../../store/VideoListStore";
import { observer } from 'mobx-react-lite';
import LanguageStore from "../../store/LanguageStore";
import { countries } from "../../constants/countries";

const CountrySelector = observer(() => {
    const {countryCode} = VideoListStore;
    const {language} = LanguageStore;

    const changeCountryCode = (value) => {
        VideoListStore.setCountryCode(value);
    }

    const getCountryName = (country) => {
        return country[language] || country.gb;
    }

    return (
        <select
            value={countryCode}
            onChange={(e) => changeCountryCode(e.target.value)}
            className="country-selector"
        >
            {countries.map((country) => (
                <option key={country.code} value={country.code}>
                    {getCountryName(country)}
                </option>
            ))}
        </select>
    );
});

export default CountrySelector;